import tableNames from 'constants/tableNames';

export const tableRoutes = {
  [tableNames.fraud]: 'fraud',
};
